/* Commented out as listing is now replaced by ct_search
(function(){
    'use strict';

        // cl_ used as Course Listing identifier


        // Click event listner on each table row to look for clicks on toggle button
        jcu_js_v1.fn.cl_rowEventListner = function(){
            var tableRows = document.querySelectorAll(".jcu-v1__course-table__row");
        
            for(var i=0; i<tableRows.length;i++){
                
                tableRows[i].addEventListener("click", function(e){
                    if (e.target.className == 'jcu-v1__course-table-toggle__btn') {
                        
                        this.classList.contains("row-expanded") ? this.classList.remove("row-expanded") : this.classList.add("row-expanded");
                        
                        this.ariaExpanded === "true" ? this.ariaExpanded = "false" : this.ariaExpanded = "true";
                    }
                });
            }
        }

        // Toggle Search refresh fade styles
        jcu_js_v1.fn.cl_toggleSeaching = function(status){
            const resultsTable = document.querySelector(".jcu-v1__course-table");
            
            if(status == true) {
                resultsTable.classList.add("loading-results");
            } else if (status == false) {
                resultsTable.classList.remove("loading-results");
            }
        }

        // Function to handle cookies for saved courses in the Course Listing table, seperate to the saved course functions within Course pages due to requirements for multiple buttons
        jcu_js_v1.fn.cl_saveCourses = function(){
        
            // Get Save buttons & browser cookie data
            const courseDetailSaveButtons = document.querySelectorAll('.jcu-v1__course-table--saved__btn');
            var savedCourseCookie = getCookieValue('jcu_saved_courses');
            // Check if cookies exists, if not, create blank cookie
            if (savedCourseCookie !== '') {    
                savedCourseCookie = JSON.parse(savedCourseCookie);
                
                // Run update Saved Courses Count Function for fixed buttons
                jcu_js_v1.fn.updateSavedCoursesCount();
                
                // console.log("initial cookies (nom nom) = ", savedCourseCookie);
                
                // For All buttons on page, apply click Event Handler & check if ID is already saved
                for(var i=0;i<courseDetailSaveButtons.length;i++){
                    
                    var assetid = courseDetailSaveButtons[i].dataset.assetid;
                    
                    if ( savedCourseCookie.indexOf(assetid) > -1 ) {
                        courseDetailSaveButtons[i].classList.add("saved");
                    }
                    
                    // Click handler, check cookie for ID and Add/Remove it accordionly
                    courseDetailSaveButtons[i].addEventListener("click", function(e){
                        e.preventDefault();
                        
                        // Gather & prep course ID and Cookie data
                        var clickedElemID = this.dataset.assetid;
                        clickedElemID = clickedElemID.toString();
                        var currentCookies = getCookieValue('jcu_saved_courses');
                        currentCookies = JSON.parse(currentCookies);
                
                        
                        // Find position of Course ID in cookie array
                        var index = currentCookies.indexOf(clickedElemID);
                        
                        // Add or Renove course ID from cookie 
                        if (index > -1) {
                            // console.log("Cookie found, deleting cookie..", clickedElemID);
                            currentCookies.splice(index, 1);
                            this.classList.remove("saved");
                        } else {
                            // console.log("Cookie  not found, adding cookie... ", clickedElemID);
                            currentCookies.push(clickedElemID);
                            this.classList.add("saved");
                        }
                        
                        // Replace cookie in browser
                            name = 'jcu_saved_courses';
                            var date, expires;
                            date = new Date();
                            //set it to 45 days
                            date.setTime(date.getTime() + (45 * 24 * 60 * 60 * 1000));
                            expires = "; expires=" + date.toGMTString();
                            var cookie = [name, '=', JSON.stringify(currentCookies), expires, '; domain=.', window.location.host.toString(), '; path=/;'].join('');
                            document.cookie = cookie;
                            
                            
                        // Re-run update Saved Courses Count Function for fixed buttons
                        jcu_js_v1.fn.updateSavedCoursesCount();
                        
                    });
                }
            } else {
                // console.log("Cookie does not exist yet, create blank");
                var emptyCookie = [];
                name = 'jcu_saved_courses';
                var date, expires;
                date = new Date();
                //set it to 45 days
                date.setTime(date.getTime() + (45 * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
                var cookie = [name, '=', JSON.stringify(emptyCookie), expires, '; domain=.', window.location.host.toString(), '; path=/;'].join('');
                document.cookie = cookie;
                
                // Rerun cookie handler event
                jcu_js_v1.fn.cl_saveCourses();
            }
        }
        
        
        
        // // Add Event Listeners to Checkbox Inputs to trigger page function and radio like functionality
        const checkboxLevel1 = document.querySelectorAll('.jcu-v1__course-search__level input[type="checkbox"]');
        const checkbocLocation1 = document.querySelectorAll('.jcu-v1__course-search__location input[type="checkbox"]');

        jcu_js_v1.fn.cl_checkboxInit = function(elements) {
        
            for(var i=0;i<elements.length;i++) {
                elements[i].addEventListener("change", function(){
                        
                    if(this.checked == true) {
                        for(var x=0;x<elements.length;x++) {
                            elements[x].checked = false;
                        };
                        this.checked = true;
                    }
                    jcu_js_v1.fn.cl_toggleSeaching(true);
                    jcu_js_v1.fn.cl_getSearchURL();
                });
            } 
        }

        // Update "Showing ... courses text"
        jcu_js_v1.fn.cl_updateSearchText = function(searchType){
            const textElem = document.querySelector(".jcu-v1__course-search__location__text");
            
            if (searchType !== undefined) {
                textElem.innerText = "Showing " + searchType.toLowerCase().replace(/\s+/g, '') + " courses for "
            } else {
                textElem.innerText = "Showing courses for "
            }
        }


    
    // Get Cookie Function
    function getCookieValue(a) {
        var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    }
    // Ajax Function
    function ajaxRequest(e,t,n,a){let s=new XMLHttpRequest;s.open(e,t,!0),"POST"==e&&s.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),s.onreadystatechange=function(){if(4==s.readyState&&200==s.status){let e=s.responseText;a(e)}},s.send(n)}
    // Debounce Function
    function debounce(n,t,u){var e;return function(){var i=this,o=arguments,a=u&&!e;clearTimeout(e),e=setTimeout(function(){e=null,u||n.apply(i,o)},t),a&&n.apply(i,o)}}



    // Function to generate search url 
    jcu_js_v1.fn.cl_getSearchURL = function(){
        
        // URL of Rest Resource that connects to funnelback './?a=1161581'; 
        const baseSearchURL = document.querySelector(".jcu-v1__course-table").dataset.searchurl;
        const studyAreaParam = '?studyArea=' + document.querySelector(".jcu-v1__course-table").dataset.studyarea;
        const campusParam = '&campus=' + document.querySelector(".jcu-v1__course-table").dataset.campus;
        
        //  Begin constructing the URL
        var searchURL = baseSearchURL + studyAreaParam + campusParam;
        
        // Get query selected options for Course Level and Course Location
        var queryOptsLevel = document.querySelectorAll('.jcu-v1__course-search__level input[type="checkbox"]:checked');
        var queryOptsLocation = document.querySelectorAll('.jcu-v1__course-search__location input[type="checkbox"]:checked');
        
        
        // Set Query Param for courseAvaliablity base on its selected checkbox value
        if (queryOptsLocation.length == 1){
            var queryOptsLocation_string = '&courseAvailability=';
            queryOptsLocation_string = queryOptsLocation_string + "both+" + queryOptsLocation[0].value;
            
            // Update SearchURL
            searchURL = searchURL + queryOptsLocation_string;
        };
        
        // Set Query Param for Study Level base on its selected checkbox value
        if (queryOptsLevel.length == 1) {
            var queryOptsLevel_string = '&studyLevel=';
            queryOptsLevel_string = queryOptsLevel_string + queryOptsLevel[0].value;
            
            // Update SearchURL
            searchURL = searchURL + queryOptsLevel_string;
        }
        
        // Send final URL to Ajax function to get search results,
        jcu_js_v1.fn.cl_getSearchResults(searchURL, queryOptsLevel);
        
    }
    
    // Debounced function to send final URL, and print new table data
    jcu_js_v1.fn.cl_getSearchResults = debounce(function(searchURL, queryOptsLevel){
        
        // console.log("searchURL == ", searchURL);
        const tableBody = document.querySelector(".jcu-v1__course-table__body");
        
        // Send Ajax request for Funnelback results with url.
        ajaxRequest("GET", searchURL, null, function(response){
            
            // Clear table and print response
            tableBody.innerHTML = '';
            
            // If no data is returned, print no results row
            if (response == '') {
                tableBody.innerHTML = '<tr class="jcu-v1__course-table__row"><td><div class="jcu-v1__course-table__row-data">Interested in a different course? <a href="https://www.jcu.edu.au/courses">Explore all courses</a></div></td></tr>';
                jcu_js_v1.fn.cl_updateSearchText();
            } else {
                tableBody.innerHTML = response;
                
                if (queryOptsLevel.length == 1){
                    jcu_js_v1.fn.cl_updateSearchText(queryOptsLevel[0].value);    
                } else {
                    jcu_js_v1.fn.cl_updateSearchText();
                }
                
            }
            
            // Rerun onload functions for Toggling more information and Saved Course icons
            jcu_js_v1.fn.cl_toggleSeaching(false);
            jcu_js_v1.fn.cl_rowEventListner();
            jcu_js_v1.fn.cl_saveCourses();
        });
        
    }, 150);

        // Run Init Funcs
        // document.addEventListener("DOMContentLoaded", function(){

            jcu_js_v1.fn.cl_rowEventListner();
            jcu_js_v1.fn.cl_saveCourses();
            jcu_js_v1.fn.cl_checkboxInit(checkboxLevel1);
            jcu_js_v1.fn.cl_checkboxInit(checkbocLocation1);

        // });

}()); */
